import { Box } from "@mui/material";
import Typography from "component/MarketPlace/Typography";
import React from "react";

export interface ITimeUpdated {
  label: string;
  date: string;
}

const TimeUpdated = (props: ITimeUpdated) => {
  const { label, date } = props;
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection={{ xs: "row", sm: "row", md: "column" }}
      padding="0 10px"
    >
      <Typography width={{xs: "72px", md: 'unset'}} marginRight="10px" variant="overline" color="text.secondary" id="lbl-timeupdated-label">
        {label}
      </Typography>

      <Typography variant="body2" color="text.secondary" id="lbl-timeupdated-date">
        {date}
      </Typography>
    </Box>
  );
};

export default TimeUpdated;
